import React, { useEffect, useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { MyCompanyDisciplinaryActionsGrid } from 'Deer/pages/Company/DisciplinaryActions/MyCompanyDisciplinaryActionsGrid';
import { AdminDisciplinaryActionsPieChart } from 'Deer/pages/Company/DisciplinaryActions/components/AdminDisciplinaryActionsPieChart';
import { BulkActionContextProvider } from 'Deer/pages/Company/DisciplinaryActions/components/BulkActionHeader/BulkActionContext';
import { useDispatch } from 'react-redux';
import { resetReviewManageSidepanelState } from 'reducers/reviewManageSidepanelSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { MODULE_KEYS } from 'constants/ProjectConstants';
import { getPersistenceKey } from 'constants/helper';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { useSelectDisciplinaryActionsSelectedIntent } from './slice/DisciplinaryActionsIntentSlice';

function MyCompanyPendingDisciplinaryActionsIntent({ gridRef }) {
  const dispatch = useDispatch();
  const cohortDetails = useSelectedView();
  const { id } = useSelectDisciplinaryActionsSelectedIntent() || {};

  /* Grid State persistence Key */
  const viewId = cohortDetails?.id;
  const gridStatePersistenceKey = useMemo(() => {
    const uniqueId = 'MyCompanyPendingDisciplinaryActionsGrid';

    return getPersistenceKey({
      moduleName: MODULE_KEYS.DISCIPLINARY_ACTIONS,
      viewId,
      tabId: '',
      uniqueId,
    });
  }, [viewId]);

  useEffect(
    () => () => {
      dispatch(resetReviewManageSidepanelState());
    },
    [dispatch]
  );

  return (
    <BulkActionContextProvider>
      <Box position="relative" display="flex" flexDirection="column" gap="10px">
        <AdminDisciplinaryActionsPieChart />
        <Box p={!checkNewNavEnabled() ? 4 : 0}>
          <PaperWithShadow p={4} mb={1} position="relative">
            <MyCompanyDisciplinaryActionsGrid
              gridRef={gridRef}
              gridStatePersistenceKey={gridStatePersistenceKey}
              intentId={id}
            />
          </PaperWithShadow>
        </Box>
      </Box>
    </BulkActionContextProvider>
  );
}

export { MyCompanyPendingDisciplinaryActionsIntent };
